<template>
  <div>
    <v-flex>
      <v-select
        label="Filtre 1"
        :value="filtre1"
        outline
        :items="tourneeFiltre1"
        @change="changeFiltre('1',$event)"
      ></v-select>
    </v-flex>
    <v-flex>
      <v-select
        label="Filtre 2"
        :value="filtre2"
        outline
        :items="tourneeFiltre2"
        @change="changeFiltre('2',$event)"
      ></v-select>
    </v-flex>
  </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import { FILTRE_MUTATION } from '@/store'

export default{
  computed: {
    ...mapState(['filtre1','filtre2']),
    ...mapGetters(['tourneeFiltre1','tourneeFiltre2']),
  },
  methods: {
    changeFiltre(filtre,value){
      this.$store.commit(FILTRE_MUTATION,{filtre,value})
    }
  }
}
</script>
